import React from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import CRMModuleHeader from "../ui/CRMModuleHeader";
import OverviewPage from "./pages/OverviewPage";
import VendorsPage from "./pages/VendorsPage";
import AssessmentsPage from "./pages/AssessmentsPage";
import VendorAssessmentPage from "./pages/VendorAssessmentPage";
import ResponsesPage from "./pages/ResponsesPage";
import RiskRegisterPage from "./pages/RiskRegisterPage";
import ApprovalsPage from "./pages/ApprovalsPage";
import EvidencePage from "./pages/EvidencePage";
import ContractsPage from "./pages/ContractsPage";
import RiskAcceptancePage from "./pages/RiskAcceptancePage";
import AuditTrailPage from "./pages/AuditTrailPage";
import QuestionnaireManagementPage from "./pages/QuestionnaireManagementPage";
import PlatformDashboardPage from "./pages/PlatformDashboardPage";
import PlatformVendorsPage from "./pages/PlatformVendorsPage";
import TPRMTabNavigation, {
  getTPRMActiveTab,
  getTPRMTabsForRole,
} from "./TPRMTabNavigation";
import { useAuth } from "../../context/AuthContext";

const TPRM = () => {
  const { user, isPlatformAdmin } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const platformAdmin =
    Boolean(isPlatformAdmin) ||
    ["admin", "platform_admin", "superadmin"].includes(
      String(user?.role || "").toLowerCase(),
    );
  const visibleTabs = getTPRMTabsForRole(platformAdmin);
  const requestedTab = searchParams.get("tab");
  const activeTab = getTPRMActiveTab(requestedTab, platformAdmin);

  const changeTab = (tabId) => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      next.set("tab", tabId);
      return next;
    });
  };

  const closeAssessmentEntry = () => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      next.delete("assessment_id");
      next.set("tab", "assessments");
      return next;
    });
  };

  return (
    <main className="mx-auto min-h-screen max-w-full p-3 sm:p-4 md:p-6 dark:bg-[#0f172a]">
      <CRMModuleHeader
        icon={ShieldCheckIcon}
        title="Third-Party Risk Management"
        description="Manage vendor risk within your authorized Tanikkai workspace."
      />

      <TPRMTabNavigation
        activeTab={activeTab}
        onTabChange={changeTab}
        tabs={visibleTabs}
      />

      {activeTab === "overview" && <OverviewPage />}
      {activeTab === "dashboard" && <PlatformDashboardPage />}
      {activeTab === "vendors" &&
        (platformAdmin ? <PlatformVendorsPage /> : <VendorsPage />)}
      {activeTab === "assessments" && <AssessmentsPage user={user} />}
      {activeTab === "responses" && <ResponsesPage />}
      {activeTab === "risk-register" && <RiskRegisterPage />}
      {activeTab === "approvals" && <ApprovalsPage />}
      {activeTab === "evidence" && <EvidencePage />}
      {activeTab === "contracts" && <ContractsPage />}
      {activeTab === "risk-acceptance" && <RiskAcceptancePage />}
      {activeTab === "audit-trail" && <AuditTrailPage />}
      {activeTab === "questionnaires" && platformAdmin && (
        <QuestionnaireManagementPage />
      )}
    </main>
  );
};

export default TPRM;
